//扣款记录管理
import { contractApi } from "@/axios";
//获取扣款记录信息
export function getDeductionRecordsPage(params, sendData) {
    return contractApi({
        url: '/deduction-records/page',
        method: 'post',
        data: sendData,
        params: params
    })
}
//删除扣款记录
export function deleteDeductionRecords(params) {
    return contractApi({
        url: '/deduction-records',
        method: 'delete',
        params: params
    })
}
//添加扣款记录
export function addDeductionRecords(data) {
    return contractApi({
        url: '/deduction-records',
        method: 'post',
        data: data
    })
}
//修改扣款记录
export function editDeductionRecords(data) {
    return contractApi({
        url: '/deduction-records',
        method: 'put',
        data: data
    })
}
//导出扣款记录
export function exportDeductionRecords(data) {
    return contractApi({
        url: '/deduction-records/export',
        method: 'post',
        data: data,
        responseType: 'blob', // 设置响应类型为 blob
    });
}